import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'VenueCategory';

const VenueCategoryApi: any = baseApi(endpoint);

export default VenueCategoryApi;